// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__14ZtP","content":"LoadingAlert_content__2zTJN"};